import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.notes.add', {
        url: '/add',
        views: {
            '@user': 'userPublicNotesAdd',
        },
    })
}


// WEBPACK FOOTER //
// ./src/portal/states/user/notes/add/add-note.state.js